<template>
<v-container fluid class="ma-2 print-page">

    <v-layout  column align-center justify-center>
    <v-col cols="10">
      <v-layout row align-center>
        <v-checkbox
          class="nonvisible mt-0"
          v-model="includePrices"
          label="Uwzględnij ceny"
          hide-details
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn  class="mr-3 nonvisible" dark color="blue darken-1" href="/zamowienia">wróć</v-btn>
        <v-btn
          color="black"
          outlined
          class="mr-3 nonvisible"
          @click="windowPrint()"
        >
          <v-icon> mdi-printer </v-icon>
        </v-btn>
      </v-layout>
    </v-col>
    <v-col cols="12">
      <v-data-table
        disable-pagination
        :headers="headers"
        :items="orders"
        hide-default-footer
        class="elevation-1 visible"
      >
      </v-data-table>
    </v-col>
    <v-col cols="12" class="mt-4 mb-12 text-center">
      <span class="font-weight-light">PROTEKTOR-POLSKA mail: logistyka@protektor-polska.pl tel: +48 884 077 377</span>
    </v-col>

  </v-layout>

  </v-container>
</template>

<script>
export default {
  methods: {
    windowPrint: function () {
      window.print();
    },
  },
  mounted() {
    this.orders = JSON.parse(localStorage.getItem("dataToPrint"));
  },
  computed: {
    headers() {
      const base = [
        { text: "Data dodania", value: "createdAtFormated" },
        { text: "ZAS", value: "id_zas" },
        { text: "ZAZ", value: "id_zaz" },
        { text: "Załadunek", value: "loading_place" },
        { text: "Rozładunek", value: "unloading_place" },
        { text: "Waga", value: "weight" },
        { text: "Dostawa", value: "delivery_method" },
        { text: "Status", value: "delivery_status" },
        { text: "Transport", value: "order_type_formated" },
        { text: "Rozliczenie", value: "drivers_settlement" },
      ];
      if (this.includePrices) {
        base.splice(6, 0, { text: "Stawka", value: "planned_transport_cost" });
      }
      return base;
    },
  },
  data() {
    return {
      includePrices: true,
      orders: [],
    };
  },
};
</script>
<style>
.print-page {
  padding-top: 72px !important;
}

@media print {
  .print-page {
    padding-top: 0 !important;
  }
  .nonvisible {
    display: none;
  }
  .v-data-table__wrapper {
    overflow: visible !important;
    max-height: none !important;
    height: auto !important;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  body
{
  margin: 1mm 1mm 1mm 1mm;
}
}
</style>